import { render } from "./GroupPicker.vue?vue&type=template&id=4ad35cb8&scoped=true"
import script from "./GroupPicker.vue?vue&type=script&lang=js"
export * from "./GroupPicker.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4ad35cb8"

export default script